/**
 * Initializes the hero module.
 * @constructor
 * @param {Object} el - The hero element.
 */
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    Modernizr = (typeof window !== "undefined" ? window['Modernizr'] : typeof global !== "undefined" ? global['Modernizr'] : null);

function Hero(el) {
  this.el = el;

  var $videoBox = $(el).find('.hero--homepage__image'),
      $video = $(el).find('video');

  Modernizr.on('videoautoplay', function(result) {
    if (result) {
      $videoBox.addClass('js-video-playing');
    } else {
      $videoBox.html('');
    }
  });

  $video.on('timeupdate', function() {
    if ($video.prop('currentTime') > $video.prop('duration') - 0.5) {
      $videoBox.removeClass('js-video-playing');
    }
  });
}

module.exports = Hero;
